import { z } from 'zod';

export const CustomerAppError = z.object({
    code: z.number(),
    message: z.string(),
    transient: z.boolean().nullish(),
});
export type CustomerAppError = z.infer<typeof CustomerAppError>;
